const envConfig = {
  "stage": "test",
  "appName": "account-registration-web",
  "appNameSuffix": "-test"
};
export default envConfig;